module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chatRoomItem"
  }, [_c('div', {
    staticClass: "roomOwnerPic"
  }, [_c('img', {
    attrs: {
      "src": _vm.roomInfo.opener_img,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "imgLine",
    class: _vm.roomInfo.room_class
  })]), _vm._v(" "), _c('div', {
    staticClass: "roomInfoArea"
  }, [_c('div', {
    staticClass: "roomTitle",
    on: {
      "click": function($event) {
        return _vm.enterRoom(_vm.roomInfo.room_uid, _vm.roomInfo.rank)
      }
    }
  }, [_vm._v(_vm._s(_vm.roomInfo.name))]), _vm._v(" "), _c('div', {
    staticClass: "roomUserCount"
  }, [(_vm.roomInfo.is_sec === 'Y') ? _c('span', {
    staticClass: "secret_room"
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.roomInfo.cur_user))]), _vm._v("/" + _vm._s(_vm.roomInfo.max_user) + " 명\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "roomOwnerName icon",
    attrs: {
      "rel": _vm.roomInfo.opener_id
    },
    domProps: {
      "innerHTML": _vm._s(_vm.roomInfo.opener_level_icon)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "roomOwnerName",
    attrs: {
      "rel": _vm.roomInfo.opener_id
    },
    on: {
      "click": _vm.showContextMenu
    }
  }, [_c('span', {
    attrs: {
      "rel": _vm.roomInfo.opener_id
    }
  }, [_vm._v(_vm._s(_vm.roomInfo.opener_name))])])]), _vm._v(" "), _c('div', {
    staticClass: "roomCreatedTime",
    domProps: {
      "innerHTML": _vm._s(_vm.roomInfo.time)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19f28e4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat-room.vue
// module id = 95
// module chunks = 0